import { render, staticRenderFns } from "./Zdfw.vue?vue&type=template&id=5909b917&scoped=true"
import script from "./Zdfw.vue?vue&type=script&lang=js"
export * from "./Zdfw.vue?vue&type=script&lang=js"
import style0 from "./Zdfw.vue?vue&type=style&index=0&id=5909b917&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909b917",
  null
  
)

export default component.exports